import type { OperatorPriceChangeLogAdminDto } from '@/backend/market'
import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { OperatorPriceChangeLogEntity } from '../../domain/entities/OperatorPriceChangeLogEntity'

export class OperatorPriceChangeLogModel extends OperatorPriceChangeLogEntity {
  constructor(dataDto: OperatorPriceChangeLogAdminDto) {
    super()
    mapEntityProperties<OperatorPriceChangeLogModel>(this, dataDto)
  }
}
